import { Avatar } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Aside extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: '1',
            profile: {
                name: "Admin",
                comp: "Ants.co.th",
                credits: "1000000",
            }
        };

        this.handleClickAccount = this.handleClickAccount.bind(this);
    }

    handleClickAccount(){
        this.props.visiblePopover();
        this.props.history.push("/accountmanagement");
    };

    render() {
        let { username } = this.props;
        return (
            <aside>

                <div className="m-0 py-3">
                    <div className="avatar float-left">
                        <Avatar className="avatar-ants" size="large">
                            <b>{username.substring(0, 2)}</b>
                        </Avatar>
                    </div>
                    <div>{username}</div>
                </div>

                {/* <hr className="mx-3 my-0" />

                <div className="m-0 py-1" style={{ cursor: "pointer" }} onClick={this.handleClickAccount}>
                    <div className="profile-icon float-left"></div>
                    &nbsp;&nbsp;Account Management
                </div> */}

                <hr className="mx-3 my-0" />

                <div className="m-0 py-3">
                    <Link to="/logout" style={{ textDecoration: 'none' }}>
                        <div className="profile-icon float-left">
                            <span className="antsicon-logout ants-orange" style={{ fontSize: 16 }}></span>
                        </div>
                        Logout
                    </Link>
                    <small className="text-muted  m-0 py-3">&nbsp;</small>
                </div>

            </aside>
        )
    }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js